import React, { useContext } from 'react'
import styled from 'styled-components'
import loadable from '@loadable/component'
import { decode } from 'shopify-gid'

import { LayoutContext } from '../../contexts'
import { useAmazonButtonClickedTracking } from '../../hooks/tracking'
import { useGlobal } from '../../hooks/useGlobal'
import { Icon } from '../shared/Icon'
import { Controls, GermanLegalAmazon } from './ProductForm'
import { useShopify } from '../../contexts/shopify'

const RichText = loadable(() => import('../RichText'))

const AmazonButton = ({
  amazonUrl,
  amazonPriceValue,
  product,
  title,
  variants,
  selectedVariant,
  sizeIndex,
}) => {
  const { node_locale, currency, storeSubdomain } = useContext(LayoutContext)
  const {
    product: { amazonButtonText, germanLegal },
  } = useGlobal(['product'], node_locale)

  const { checkouts: allCheckouts, replaceSizeVariants } = useShopify()
  const checkouts = allCheckouts[storeSubdomain]

  return amazonUrl && amazonButtonText ? (
    <>
      <Controls>
        <AmazonLink
          href={amazonUrl}
          target='_blank'
          onClick={() =>
            useAmazonButtonClickedTracking({
              currency: currency?.code,
              locale: node_locale,
              checkoutId: checkouts.id && decode(checkouts.id).id,
              productId: selectedVariant && decode(selectedVariant).id,
              sku: variants[sizeIndex].node.sku,
              name: title,
              price:
                amazonPriceValue ||
                product?.variants.edges[0].node.presentmentPrices.edges.find(
                  ({
                    node: {
                      price: { currencyCode },
                    },
                  }) => currencyCode === currency.code,
                ).node.price.amount,
              value:
                amazonPriceValue ||
                product?.variants.edges[0].node.presentmentPrices.edges.find(
                  ({
                    node: {
                      price: { currencyCode },
                    },
                  }) => currencyCode === currency.code,
                ).node.price.amount,
              url: amazonUrl,
            })
          }
        >
          <AmazonWrapper>
            <p>{amazonButtonText}</p>
            <Icon name='amazon' />
          </AmazonWrapper>
        </AmazonLink>
      </Controls>
      {node_locale === 'de' && (
        <GermanLegalAmazon>
          <RichText json={germanLegal} />
        </GermanLegalAmazon>
      )}
    </>
  ) : (
    node_locale === 'de' && (
      <GermanLegal>
        <RichText json={germanLegal} />
      </GermanLegal>
    )
  )
}

const AmazonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`

const AmazonLink = styled.a`
  height: 85%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: #000;
  background: rgb(228 175 74 / 20%);
  font-size: ${(props) => props.theme.fontSize.m26};
  cursor: pointer;
  letter-spacing: 0.025em;
  border: 1px solid rgb(228, 175, 74);

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d14};
  }

  p {
    position: relative;
    top: 0.4vw;
    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      top: 0.15vw;
    }
  }

  svg {
    width: 16vw;
    margin-left: 1.5vw;
    position: relative;
    top: 1.25vw;

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      width: 4.3vw;
      margin-left: 0.4vw;
      top: 0.4vw;
    }
  }
`

const GermanLegal = styled.div`
  font-size: ${(props) => props.theme.fontSize.m23};
  padding-bottom: ${(props) => props.theme.space.marginMobile}vw;
  letter-spacing: 0.025em;
  color: #2b2b2b;

  a {
    color: #2b2b2b !important;
    text-decoration: underline !important;
  }

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d12};
    padding-bottom: ${(props) => props.theme.space.marginDesktop * 2}vw;
  }
`

export default AmazonButton
